/* eslint max-len: 0 */
import React, { SVGProps } from "react";

const MobilePhone = (props: SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg width="22" height="30" viewBox="0 0 22 30" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.66667 0C2.98477 0 0 2.98477 0 6.66667V22.6667C0 23.1233 0.045907 23.5692 0.133358 24H2.66667V6.66667C2.66667 4.45753 4.45753 2.66667 6.66667 2.66667H14.6667C16.8758 2.66667 18.6667 4.45753 18.6667 6.66667V24H21.2C21.2874 23.5692 21.3333 23.1233 21.3333 22.6667V6.66667C21.3333 2.98477 18.3486 0 14.6667 0H6.66667Z"
        fill="currentColor"
      />
      <path
        d="M20.0005 26.6667H1.33285C2.54912 28.2859 4.48558 29.3333 6.66667 29.3333H14.6667C16.8478 29.3333 18.7842 28.2859 20.0005 26.6667Z"
        fill="currentColor"
      />
      <path
        d="M11.3333 24C12.0697 24 12.6667 23.403 12.6667 22.6667V21.3333C12.6667 20.597 12.0697 20 11.3333 20H10C9.26362 20 8.66667 20.597 8.66667 21.3333V22.6667C8.66667 23.403 9.26362 24 10 24H11.3333Z"
        fill="currentColor"
      />
      <path d="M15.3333 5.33333H6V8H15.3333V5.33333Z" fill="currentColor" />
    </svg>
  );
};

MobilePhone.displayName = "MobilePhone";

export default MobilePhone;
